export default __webpack_public_path__ + "static/media/icon_2_1.c3b26582.svg";